import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import useStyles from '../../assets/styles/style';
import VendorHeading from '../../components/vendor/VendorFormHeading';
import VendorForm from '../../components/vendor/VendorForm';
import { Divider } from '@mui/material';

const VendorMain = () => {
  const classes = useStyles(); 
  return (
    <div className={classes.formMainContainer}>
      <Box className={classes.formMainHeadingBox}>
        <VendorHeading />
      </Box>
      <Divider />
      <Box component="main" className={classes.formMainBox}>
        <Paper className={classes.formMainpaper}>
          <VendorForm />
        </Paper>
      </Box>
    </div>
  );
};

export default VendorMain;
